// extracted by mini-css-extract-plugin
module.exports = {"menu":"Menu_menu__Eaifw","menuContainer":"Menu_menuContainer__AVg_A","isOpen":"Menu_isOpen__CBafu","mobile":"Menu_mobile__DyUpX"};